import { Progress } from 'antd'

const ANTDProgress = props => {
  return <Progress {...props} />
}

export default ANTDProgress
